
export async function callProxy(path, token, opts = {}) {


  const proxyBase =
    window.location.hostname === "localhost"
      ? "http://localhost:4000"
      : "https://api.highendholidays.ae";
  // const proxyBase = process.env.REACT_APP_API_URL || "https://backend-highend.onrender.com";

  // const proxyBase = process.env.REACT_APP_API_URL || "http://localhost:4000";
//  : "https://api.highendholidays.ae";

  const headers = { "Content-Type": "application/json" };
  if (token) headers["Api-Key"] = token;

  const body =
    opts.method === "POST" || opts.method === "PUT"
      ? JSON.stringify(opts.body || {})
      : undefined;

  const res = await fetch(`${proxyBase}${path}`, {
    method: opts.method || "GET",
    headers,
    body,
  });

  const data = await res.json().catch(() => ({})); // Avoid errors on <html>
  return { status: res.status, data };
}